module.exports = __webpack_public_path__ + "img/reparation-pro.67cb1a1a.svg";